import Icon from '@ant-design/icons';
import type { CustomIconComponentProps, IconComponentProps } from '@ant-design/icons/lib/components/Icon';

type IconProps = Pick<IconComponentProps, 'onClick'>;

const PreviewIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M12.9105 15.2083C12.1055 15.2083 11.4522 15.8617 11.458 16.6667C11.458 17.4717 12.1114 18.125 12.9164 18.125C13.7214 18.125 14.3747 17.4717 14.3747 16.6667C14.3747 15.8617 13.7214 15.2083 12.9105 15.2083"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.8333 12.5H4.16667C3.24583 12.5 2.5 11.7542 2.5 10.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V10.8333C17.5 11.7542 16.7542 12.5 15.8333 12.5Z"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.5 16.6667H11.4583"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.375 16.6667H17.5"
            stroke="#001965"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

const PreviewIcon = (props: Partial<CustomIconComponentProps & IconProps>) => (
    <Icon component={() => <PreviewIconSVG />} {...props} />
);

export default PreviewIcon;
